var map = {
	"./discord_bot/discord_bot_canvas.png": "7bed",
	"./discord_bot/discord_bot_icon.png": "b8a9",
	"./discord_bot/discord_bot_large_canvas.jpg": "063e",
	"./food_savior/food_savior_canvas.png": "c189",
	"./food_savior/food_savior_icon.png": "82f0",
	"./food_savior/food_savior_splash.png": "fae5",
	"./gallery/gallery_bg_1.jpg": "0bea",
	"./initial_d/initial_d_bg.jpg": "3bde",
	"./initial_d/initial_d_canvas.jpg": "58c0",
	"./initial_d/initial_d_icon.jpg": "0bd2",
	"./jibaboom_astronomia/jibaboom_astronomia_bg.png": "caaf",
	"./jibaboom_astronomia/jibaboom_astronomia_canvas.png": "1b76",
	"./old_portfolio/old_portfolio_canvas.png": "df1c",
	"./old_portfolio/old_portfolio_icon.png": "a829",
	"./shopmania/shopmania_canvas.png": "d6cc",
	"./shopmania/shopmania_icon.png": "c78f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";